import React from 'react';
import { mapIcon } from '../../utils/mapIcon';
import TipsAndTricks from '../TipsAndTricks';
import Category from '../Category';
import type { AdviceTheme, AdviceResponse } from '../../types/product';

interface Props {
  theme: AdviceTheme;
  adviceResponseObject: AdviceResponse;
  themeImageMap: Record<string, string>;
  isKuuraAdvice?: boolean;
}

const ThemeResult = ({ theme, adviceResponseObject, themeImageMap, isKuuraAdvice = false }: Props) => (
  <div className="sm:p-10 sm:bg-white mt-6 lg:mt-5 lg:rounded-[20px]">
    {!isKuuraAdvice && (
      <div className="inline-flex items-end gap-2.5">
        <img
          src={'/assets/images/' + (themeImageMap[theme.theme] || mapIcon(theme.theme)) + '.svg'}
          alt={theme.theme + ' icon'}
          className="h-10 w-10"
        />
        <span className="text-4xl lg:text-2xl font-semibold capitalize">{theme.theme}</span>
      </div>
    )}
    <h4 className="mt-4 lg:mt-5">Producten</h4>
    {isKuuraAdvice ? (
      <p className="mt-1 lg:mt-2.5">Op basis van jouw Kuura profiel hebben we de volgende bijpassende hulpmiddelen gevonden:</p>
    ) : theme.advice.productCategories.some((cat) => cat.products.length) ? (
      <p className="mt-1 lg:mt-2.5">Voor jouw score op {theme.theme} hebben we de volgende bijpassende producten gevonden</p>
    ) : (
      <p className="mt-1 lg:mt-2.5">Geen producten</p>
    )}
    {theme.advice.productCategories.map((category) => (
      <Category
        key={theme.theme + '-' + category.id}
        category={category}
        allowedProducts={theme.advice.products}
        adviceResponseObject={adviceResponseObject}
      />
    ))}
    <TipsAndTricks content={theme.advice.content} adviceResponseObject={adviceResponseObject} />
  </div>
);

export default ThemeResult;
